import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TSubmitWorkerPaycardSSNIDVerificationRequest } from "./submitWorkerPaycardSSNIDVerification.schema";

export const submitWorkerPaycardSSNIDVerification = (axios: IAxiosInstance) => {
  return async (body: TSubmitWorkerPaycardSSNIDVerificationRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<boolean>>(
      "/api/submitWorkerPaycardSSNIDVerification",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
